module.exports = __webpack_public_path__ + "img/logo.bce0c3ed.jpg";